import PropTypes from 'prop-types';
import React from 'react';

import trainTime from '../../lib/TrainTime';
import Search from '../../records/SeasonSearch';
import { translate as t } from '../../lib/I18n';
import { SeasonCustomRange } from '../../constants/AppConstants';

import Icon from '../general/Icon';
import DateSummary from '../form/DateSummary';
import PureRenderComponent from '../PureRenderComponent';


class SeasonCustomSummary extends PureRenderComponent {

    static propTypes = {
        search: PropTypes.instanceOf(Search).isRequired,
        onChange: PropTypes.func.isRequired
    };

    _handleDateSelect = (date) => {
        const convertedDate = trainTime(date.format('YYYY-MM-DD'));
        const dates = this.props.search.dates.setEndDate(convertedDate.clone());
        const search = this.props.search.set('dates', dates);

        this.props.onChange(search);
    };

    _getInclusiveDate (duration) {
        const startDate = this.props.search.dates.getStartDate();
        return trainTime(startDate).add(trainTime.duration(duration)).subtract(1, 'day');
    }

    render () {
        const endDate = this.props.search.dates.getEndDate();
        const dateSummaryProps = {
            modalTitle: 'season.custom.modal.title',
            onChange: this._handleDateSelect,
            selected: endDate,
            min: this._getInclusiveDate(SeasonCustomRange.MIN),
            max: this._getInclusiveDate(SeasonCustomRange.MAX)
        };
        return (
                <DateSummary { ...dateSummaryProps }>
                    <span className="datetime__selected-date pull-left">
                        <time className="clearfix" dateTime={ endDate && endDate.format() }>
                            <span className="text-light datetime__fixed-width pull-left">
                                { t('season.custom.summary.text') }
                            </span>
                        </time>
                        { endDate ? endDate.format('ddd DD MMM YYYY') : t('season.select.endDate')}
                    </span>
                    <Icon className="pull-right box__icon" icon="calendar" />
                </DateSummary>
        );
    }

}

export default SeasonCustomSummary;



// WEBPACK FOOTER //
// ./src/components/seasonTicket/SeasonCustomSummary.js